"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagPickerControl: function() {
        return _index.TagPickerControl;
    },
    iconSizes: function() {
        return _index.iconSizes;
    },
    renderTagPickerControl_unstable: function() {
        return _index.renderTagPickerControl_unstable;
    },
    tagPickerControlAsideWidthToken: function() {
        return _index.tagPickerControlAsideWidthToken;
    },
    tagPickerControlClassNames: function() {
        return _index.tagPickerControlClassNames;
    },
    useTagPickerControlStyles_unstable: function() {
        return _index.useTagPickerControlStyles_unstable;
    },
    useTagPickerControl_unstable: function() {
        return _index.useTagPickerControl_unstable;
    }
});
const _index = require("./components/TagPickerControl/index");
